import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { userClient } from '../client/userClient';


type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useUsersQuery = (params: Users.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getUsers, params],
    queryFn: () => userClient.getUsers(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    users: data?.results || [],
  };
};
